import { useEffect, useState } from 'react';
import getDocumentHistory from '../../api/documents/getDocumentHistory';
import { useParams } from 'react-router-dom';
import extractErrorMessage from '../../utils/extractErrorMessage';
import alert from '../../helpers/alert';
import LoaderInline from '../../components/Loader/LoaderInline';
import dayjs from 'dayjs';
import DownloadFileLink from '../../components/DownloadFileLink/DownloadFileLink';
import { BANKS } from '../../constants';
import formatSignedAt from '../../utils/formatSignedAt';

const History = () => {
  const [document, setDocument] = useState(null);
  const [documentHistory, setDocumentHistory] = useState(null);
  const [loading, setLoading] = useState(false);
  const { documentId } = useParams();

  const [signatory, setSignatory] = useState(null);

  const init = async () => {
    setLoading(true);
    try {
      if (window.location.hostname === 'test-broker.doscar.kz') {
        const currentUrl = window.location.href;
        const redirectUrl = currentUrl.replace('test-broker', 'broker');
        window.location = redirectUrl;
      }

      const { data } = await getDocumentHistory(documentId);

      //ÑÐµÐ´Ð¸ÑÐµÐºÑ Ð½Ð° Ð¿Ð´Ñ Ð´Ð»Ñ ÑÑÐ¸Ð´Ð¾Ð¼Ð°
      // if (data?.document?.serialNumberId === BANKS.FREEDOM) {
      //   return window.location = data?.document?.url;
      // }

      data.history = data?.history?.map((item) => ({
        ...item,
        createdAt: dayjs(item?.createdAt).format('DD.MM.YYYY hh:mm:ss'),
      }));

      setDocumentHistory(data?.history);
      setDocument(data?.document);
      setSignatory(data?.signatory);
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ð¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, [documentId]);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '90vh',
        }}
      >
        <LoaderInline />
      </div>
    );
  }

  const isFreedom = document?.serialNumberId === BANKS.FREEDOM;

  return (
    <div
      style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: 20,
      }}
    >
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>
        {isFreedom ? 'ÐÐ¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°' : 'ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð¿Ð¾Ð´Ð»ÐµÐ½Ð½Ð¾ÑÑÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°'}
      </h2>
      {/* Ð¡ÑÑÐ»ÐºÐ° Ð½Ð° ÑÐ°Ð¹Ð» Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿ÑÐ¸ Ð¾ÑÐºÑÑÑÐ¸Ð¸ Ð¿Ð¾ ÑÐ¾ÐºÐµÐ½Ñ, Ð¿Ð¾ ÑÐ¸ÑÐ»Ð¾Ð²Ð¾Ð¼Ñ id ÐµÑ Ð½ÐµÑ. */}
      {document?.url && <DownloadFileLink document={document} />}

      {isFreedom ? (
        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
          {signatory && (
            <div>
              <strong>ÐÐ¾Ð´Ð¿Ð¸ÑÐ°Ð½Ñ: </strong>
              <span>
                {[signatory?.surname, signatory?.name, signatory?.middlename]
                  .filter(Boolean)
                  .join(' ')}
                {signatory?.iin ? `, ÐÐÐ: ${signatory.iin}` : ''}
                {signatory?.phone ? `, ÑÐµÐ»: ${signatory.phone}` : ''}
              </span>
            </div>
          )}
          <div>
            <strong>Ð¡Ð¿Ð¾ÑÐ¾Ð± Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ: </strong>
            <span>{document?.signType === 1 ? 'Ð­Ð¦Ð' : 'SMS-ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ'}</span>
          </div>
          <div>
            <strong>ÐÐ°ÑÐ° Ð¸ Ð²ÑÐµÐ¼Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ: </strong>
            <span>
              {formatSignedAt(document?.signedAt)}
            </span>
          </div>
        </div>
      ) : (
        <ul
          style={{
            listStyle: 'decimal',
            paddingLeft: 15,
          }}
        >
          {documentHistory?.map((item) => (
            <li style={{ marginBottom: 10 }}>
              <strong>{item?.createdAt}</strong> - <span>{item?.message}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default History;
